var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "scroll-to", on: { click: _vm.scrollToSection } },
    [
      _c("icon", {
        staticClass: "scroll-to__arrow",
        style: _vm.iconStyles,
        attrs: { name: "arrow-left", size: "18px" },
      }),
      _c("span", { staticClass: "scroll-to__text" }, [
        _vm._v(_vm._s(_vm.ctaText)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }